module.exports = __webpack_public_path__ + "static/media/Leonidas.d797fe2d.jpg";